import styled from 'styled-components';
import { formatDate } from '@superdispatch/dates';
import { ColorDynamic } from '@superdispatch/ui';
import { LoadDTO } from '../data/LoadDTO';
import { ViewLoadPaymentCardRow } from './ViewLoadPaymentRenderCardRow';

export const PaymentDetailsWithBorder = styled.div`
  border-left: 1px solid ${ColorDynamic.Silver500};
  margin-left: 7px;
  padding-left: 12px;
`;

interface InvoiceDetailsParams {
  subhaulerInvoice?: LoadDTO['subhauler_invoice'];
  defaultValuePlaceholder: string;
}
export function ViewSubhaulerInvoiceDetails({
  subhaulerInvoice,
  defaultValuePlaceholder,
}: InvoiceDetailsParams) {
  return (
    <PaymentDetailsWithBorder>
      <ViewLoadPaymentCardRow
        title="Received On"
        value={
          subhaulerInvoice?.received_at
            ? formatDate(subhaulerInvoice.received_at, {
                variant: 'DateTime',
              })
            : defaultValuePlaceholder
        }
      />
    </PaymentDetailsWithBorder>
  );
}
